import { Svg } from '../../../components/Svg';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LookalikeListsIcon = () => {
  return /*#__PURE__*/_jsxs(Svg, {
    $size: "32px",
    $color: "currentColor",
    $alignWithText: false,
    viewBox: "0 0 32 32",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M4.50667 12.2539L15.5733 18.6406C15.7333 18.7339 15.9067 18.7739 16.08 18.7739C16.2533 18.7739 16.4267 18.7339 16.5867 18.6406L27.6533 12.2539C27.96 12.0806 28.16 11.7472 28.16 11.3872C28.16 11.0272 27.9733 10.6939 27.6533 10.5206L16.5733 4.13391C16.2667 3.96057 15.88 3.96057 15.5733 4.13391L4.50667 10.5206C4.2 10.6939 4 11.0272 4 11.3872C4 11.7472 4.18667 12.0806 4.50667 12.2539ZM16.0667 6.16057L25.1333 11.4006L16.0667 16.6406L7 11.4006L16.0667 6.16057Z",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("path", {
      d: "M27.9998 15.4939C27.7198 15.0139 27.1065 14.8539 26.6398 15.1339L16.0798 21.2272L5.50651 15.1339C5.02651 14.8539 4.41317 15.0272 4.14651 15.4939C3.87984 15.9605 4.03984 16.5872 4.50651 16.8539L15.5732 23.2405C15.7332 23.3339 15.9065 23.3739 16.0798 23.3739C16.2532 23.3739 16.4265 23.3339 16.5865 23.2405L27.6532 16.8539C28.1332 16.5739 28.2932 15.9605 28.0132 15.4939H27.9998Z",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("path", {
      d: "M26.6398 19.7472L16.0798 25.8405L5.50651 19.7472C5.02651 19.4672 4.41317 19.6405 4.14651 20.1072C3.87984 20.5738 4.03984 21.2005 4.50651 21.4672L15.5732 27.8538C15.7332 27.9472 15.9065 27.9872 16.0798 27.9872C16.2532 27.9872 16.4265 27.9472 16.5865 27.8538L27.6532 21.4672C28.1332 21.1872 28.2932 20.5738 28.0132 20.1072C27.7332 19.6272 27.1198 19.4672 26.6532 19.7472H26.6398Z",
      fill: "currentColor"
    })]
  });
};
export default LookalikeListsIcon;